import type { ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Yon panel (tafsilot).
 *
 * `document.body` ga PORTAL orqali chiziladi: sahifa kartalari shisha
 * (`backdrop-filter`) va animatsiya (`transform`) ishlatadi, bunday
 * ota ichida `position: fixed` ekranga emas, o'sha kartaga
 * bog'lanadi — panel sahifa oxirida, ko'rinmas joyda ochilardi.
 */
export function Drawer({ label, children }: { label: string; children: ReactNode }) {
  return createPortal(
    <aside className="drawer glass-thick" role="dialog" aria-label={label}>
      {children}
    </aside>,
    document.body,
  );
}
